'use client';

import React, { useState } from 'react';
import dynamic from 'next/dynamic';

const LeagueXGoalsChart = dynamic(() => import('./LeagueXGoalsChart'), { ssr: false });
const PPPKTrendChart = dynamic(() => import('./PPPKTrendChart'), { ssr: false });

export default function TrendChartsSection() {
  const [activeMetric, setActiveMetric] = useState<'xgoals' | 'ppk'>('xgoals');

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-4">
      <div className="card p-4">
        <div className="flex items-center justify-between mb-3">
          <div>
            <h3 className="text-sm font-semibold text-foreground">xGoals Ligue — Tendance Saison</h3>
            <p className="text-xs text-muted-foreground mt-0.5">Moyenne ligue xGF par match (rolling 5)</p>
          </div>
        </div>
        <LeagueXGoalsChart />
      </div>
      <div className="card p-4">
        <div className="flex items-center justify-between mb-3">
          <div>
            <h3 className="text-sm font-semibold text-foreground">PP% vs PK% — Corrélation</h3>
            <p className="text-xs text-muted-foreground mt-0.5">Efficacité jeux de puissance et infériorité</p>
          </div>
          <div className="flex gap-1">
            {(['xgoals', 'ppk'] as const).map((m) => (
              <button
                key={`metric-${m}`}
                onClick={() => setActiveMetric(m)}
                className={`px-2 py-1 rounded text-2xs font-medium transition-all ${activeMetric === m ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground hover:text-foreground'}`}
              >
                {m === 'xgoals' ? 'xGoals' : 'PP/PK'}
              </button>
            ))}
          </div>
        </div>
        <PPPKTrendChart />
      </div>
    </div>
  );
}